import { addPageViewEntryInActionsHistory } from './ipx-actions-history-actions.js';
export function loadIPXActionsHistoryActions(engine) {
    engine.addReducers({});
    return {
        addPageViewEntryInActionsHistory,
    };
}
